import { differenceInDays } from 'date-fns';

import { baseApi } from '../../../../app/baseApi';
import { ChartData, DataCorrectionState, DataCorrectionType } from './data-correction-helpers';

const DATA_CORRECTION_TYPE_TO_ENDPOINT_MAP: Record<DataCorrectionType, string> = {
  energyUsage: 'usage',
  costs: 'costs',
  savings: 'savings',
  batteryData: 'battery_data',
};

const getIntervalBasedOnDateRange = (startDate: string, endDate: string) => {
  const difference = differenceInDays(new Date(endDate), new Date(startDate));
  if (difference > 90) return 'month';
  if (difference > 14) return 'week';
  if (difference > 0) return 'day';
  return 'default';
};

export const dataCorrectionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChartData: builder.query<ChartData, DataCorrectionState>({
      query: ({ siteId, type, startDate, endDate }) => {
        const interval = getIntervalBasedOnDateRange(startDate, endDate);
        return `/v1/sites/${siteId}/data_correction/${DATA_CORRECTION_TYPE_TO_ENDPOINT_MAP[type]}?start_date=${startDate}&end_date=${endDate}&interval=${interval}`;
      },
      providesTags: (_, __, { siteId, type: correctionType, startDate, endDate }) => [
        { type: 'DataCorrectionChartData', siteId, correctionType, startDate, endDate },
      ],
    }),
    postDataCorrection: builder.mutation<void, DataCorrectionState>({
      query: ({ siteId, type, startDate, endDate }) => {
        return {
          url: `/v1/sites/${siteId}/data_correction?type=${type}&start_date=${startDate}&end_date=${endDate}`,
          method: 'POST',
          body: {},
        };
      },
    }),
    postBackfillHistory: builder.mutation<void, Pick<DataCorrectionState, 'siteId' | 'type'>>({
      query: ({ siteId, type }) => {
        return {
          url: `/v1/sites/${siteId}/backfill_history?type=${type}`,
          method: 'POST',
          body: {},
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetChartDataQuery, usePostDataCorrectionMutation, usePostBackfillHistoryMutation } =
  dataCorrectionApi;
